import Modal from "../Modal";
import { PointExchangeType } from "../../enums/pointExchangeType";
import { useEffect, useState } from "react";
import { sendPostRequest } from "../../utils";
import { Button, MenuItem, Select } from "@mui/material";
import Loader from "../Loader";

const EmployeeRewardForm = ({ open, onClose, employee, doFetchEmployees }) => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState({
    type: PointExchangeType.GIFT_CARDS,
    points: "",
    name: "",
    description: "",
    employee_id: employee?.id || null,
  });

  const onInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setIsLoading(true);
    setError(null);

    try {
      const response = await sendPostRequest("employees/redeem-points", form);
      const data = await response.json();
      if (response.ok) {
        onClose();
      } else {
        setError(data.message || "Failed to redeem points.");
      }

      doFetchEmployees();
    } catch (error) {
      console.log(error);
      setError("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const typeOptions = Object.values(PointExchangeType).map((type) => ({
    value: type,
    label: type.replaceAll("_", " "),
  }));

  useEffect(() => {
    if (open && employee && employee.id) {
      setForm((prev) => ({
        ...prev,
        points: "",
        name: "",
        description: "",
        employee_id: employee.id,
      }));
    }
  }, [open, employee]);

  return (
    <Modal
      open={open}
      handleClose={onClose}
      style={{ width: "420px", backgroundColor: "#f5f5f5" }}
    >
      <div className="flex flex-col gap-4">
        <h1 className="text-xl font-bold">Exchange Points</h1>
        <div className="space-y-2">
          {error && (
            <div className="text-red-500 bg-red-50 border-red-200 border text-base px-2 py-1 mb-4">
              {error}
            </div>
          )}
          <form
            onSubmit={handleSubmit}
            className="space-y-4"
            encType="multipart/form-data"
          >
            <div className="grid grid-cols-12 gap-4">
              <div className="flex flex-col col-span-8">
                <label className="mb-2 text-sm font-semibold text-gray-800">
                  Type
                </label>
                <Select
                  value={form.type}
                  onChange={onInputChange}
                  required
                  placeholder=""
                  name="type"
                  disabled={isLoading}
                  size="small"
                  className="!h-[42px] capitalize bg-white"
                >
                  {typeOptions.map((option) => (
                    <MenuItem
                      key={option.value}
                      value={option.value}
                      className="capitalize"
                      onClick={() => {
                        setForm((prev) => ({
                          ...prev,
                          type: option.value,
                        }));
                      }}
                    >
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </div>
              <div className="flex flex-col col-span-4">
                <label className="mb-2 text-sm font-semibold text-gray-800">
                  Points
                </label>
                <input
                  value={form.points}
                  type="number"
                  name="points"
                  onChange={onInputChange}
                  required
                  className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder=""
                  disabled={isLoading}
                />
              </div>
            </div>
            <div className="flex flex-col">
              <label className="mb-2 text-sm font-semibold text-gray-800">
                Name
              </label>
              <input
                value={form.name}
                type="text"
                name="name"
                onChange={onInputChange}
                required
                className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder=""
                disabled={isLoading}
              />
            </div>
            <div className="flex flex-col">
              <label className="mb-2 text-sm font-semibold text-gray-800">
                Description
              </label>
              <textarea
                name="description"
                value={form.description}
                onChange={onInputChange}
                rows={5}
                className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
                placeholder=""
              />
            </div>
            <div>
              <div className="flex gap-2 mt-10">
                <Button
                  type="submit"
                  disabled={isLoading}
                  variant="contained"
                  className="w-1/2"
                >
                  {isLoading ? <Loader /> : ""}
                  Redeem Points
                </Button>
                <Button
                  type="button"
                  disabled={isLoading}
                  variant="outlined"
                  className="w-1/2"
                  onClick={onClose}
                >
                  <span>Cancel</span>
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
};

export default EmployeeRewardForm;
